export function common() {
  

  //お問い合わせ　ラジオボタンに連動で非表示
  $(function() {
    function toggleHide() {
      const checkedVal = $('input[name="type"]:checked').val();
      if (checkedVal === '店舗に関するご意見・お問い合わせ（店舗へのご予約を除く）') {
        $('.js-target--store_name').removeClass('is-hide');
      } else {
        $('.js-target--store_name').addClass('is-hide');
      }
    }
    toggleHide();
    $('input[name="type"]').on('change', toggleHide);
  });

  // checkboxが存在する場合のみ処理を実行
  if ($('input[name="agreement[]"]').length > 0) {
    function toggleSubmit() {
      const isChecked = $('input[name="agreement[]"]').is(':checked');
      const $submitBtn = $('input[type="submit"]');
      
      if (isChecked) {
        $submitBtn.css({
          'pointer-events': 'auto',
          'opacity': 1
        });
      } else {
        $submitBtn.css({
          'pointer-events': 'none',
          'opacity': 0.5
        });
      }
    }

    // ページ読み込み時とcheckbox変更時に判定
    toggleSubmit();
    $('input[name="agreement[]"]').on('change', toggleSubmit);
  }

  $(document).ready(function() {
    $('input[name="type"]').on('change', function() {
        // 何番目かを取得
        const index = $('input[name="type"]').index(this);
        // 同じインデックスのラジオボタンを checked にする
        $('input[name="type-mail"]').eq(index).prop('checked', true);
    });
  });
  
}